module.exports = __webpack_public_path__ + "img/image.96e5db04.png";